"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class GridduckInvoice extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'gridduckInvoice';
        this._total = initParams.total;
        this._totalDiscountAmounts = (0, util_1.camelArray)(initParams.total_discount_amounts);
        this._description = initParams.description;
        this._status = initParams.status;
        this._number = initParams.number;
        this._created = initParams.created;
        this._hostedInvoiceUrl = initParams.hosted_invoice_url;
    }
    set total(value) {
        console.error('Do not set objects this way');
    }
    get total() {
        return this._total;
    }
    set totalDiscountAmounts(value) {
        console.error('Do not set objects this way');
    }
    get totalDiscountAmounts() {
        return this._totalDiscountAmounts;
    }
    set description(value) {
        console.error('Do not set objects this way');
    }
    get description() {
        return this._description;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    get status() {
        return this._status;
    }
    set number(value) {
        console.error('Do not set objects this way');
    }
    get number() {
        return this._number;
    }
    set created(value) {
        console.error('Do not set objects this way');
    }
    get created() {
        return this._created;
    }
    set hostedInvoiceUrl(value) {
        console.error('Do not set objects this way');
    }
    get hostedInvoiceUrl() {
        return this._hostedInvoiceUrl;
    }
}
exports.default = GridduckInvoice;
//# sourceMappingURL=gridduckInvoice.js.map